// 绝对定位节点的布局

const container = () => {
  return {
    display: "inline-block"
  };
};

export default container;
